import React from 'react';
import { RolloverStatusFiltersProps } from '../types/RolloverStatusTypes';
import { FiltersContainer, FilterColumn, StyledTextField } from '../styled';
import DropdownSelect from '../../../components/DropdownSelect';
import { isEmpty } from 'lodash';

const RolloverStatusFilters: React.FC<RolloverStatusFiltersProps> = ({
  academicYear,
  setAcademicYear,
  grade,
  setGrade,
  gradeOptions,
  academicYearOptions,
  setHasSearched,
  selectedSchool,
  setSelectedSchool,
  userSchools = []
}) => {
  const handleAcademicYearChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | (Event & { target: { value: unknown; name: string } })
  ) => {
    const target = e.target as HTMLInputElement & { value: string };
    setAcademicYear(target.value);
    setHasSearched(false);
  };

  const handleGradeChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | (Event & { target: { value: unknown; name: string } })
  ) => {
    const target = e.target as HTMLInputElement & { value: string };
    setGrade(target.value);
    setHasSearched(false);
  };

  const handleSchoolChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | (Event & { target: { value: unknown; name: string } })
  ) => {
    const school = e.target as HTMLInputElement & { value: string };
    if (setSelectedSchool) setSelectedSchool(school.value);
    if (setGrade) setGrade('All Grades');
    setHasSearched(false);
  };

  const schoolOptions = (userSchools || []).map((school) => ({
    value: school,
    label: school
  }));
  
  return (
    <FiltersContainer>
      {!isEmpty(userSchools) && (
        <FilterColumn>
          <StyledTextField>
            <DropdownSelect
              label='School'
              name='school'
              value={selectedSchool || ''}
              onChange={handleSchoolChange}
              options={schoolOptions}
              size='small'
              placeholder='Select School'
            />
          </StyledTextField>
        </FilterColumn>
      )}
      <FilterColumn>
        <StyledTextField>
          <DropdownSelect
            label='Academic Year'
            name='academicYear'
            value={academicYear}
            onChange={handleAcademicYearChange}
            options={academicYearOptions.map((a) => ({
              value: a.value,
              label: a.label
            }))}
            size='small'
            placeholder='Select Academic Year'
          />
        </StyledTextField>
      </FilterColumn>
      <FilterColumn>
        <StyledTextField>
          <DropdownSelect
            label='Grade'
            name='grade'
            value={grade}
            onChange={handleGradeChange}
            options={gradeOptions.map((g: any) => ({
              value: g.value,
              label: g.label
            }))}
            size='small'
            placeholder='Select Grade'
          />
        </StyledTextField>
      </FilterColumn>
    </FiltersContainer>
  );
};

export default RolloverStatusFilters;
